"use client";

import { useToast } from "@/components/ui/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { cn } from "@/lib/utils";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className={cn(
              "grid gap-1",
              props.variant === "destructive" ? 'text-white' : 'text-black'
            )}>
              {title && <p className="text-xl 2k:text-2xl 4k:text-4xl font-bold">{title}</p>}
              {description && <p className="text-md 2k:text-lg 4k:text-xl">{description}</p>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
